'use strict';

module.exports = typeof self === 'object' && self.self === self && self || typeof global === 'object' && global.global === global && global || this;